(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[76360],{

/***/ 55315:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// THIS FILE IS AUTO GENERATED
var GenIcon = (__webpack_require__(15787)/* .GenIcon */ .w_)
module.exports.d = function BsSearch (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 16 16","fill":"currentColor"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M10.442 10.442a1 1 0 011.415 0l3.85 3.85a1 1 0 01-1.414 1.415l-3.85-3.85a1 1 0 010-1.415z","clipRule":"evenodd"}},{"tag":"path","attr":{"fillRule":"evenodd","d":"M6.5 12a5.5 5.5 0 100-11 5.5 5.5 0 000 11zM13 6.5a6.5 6.5 0 11-13 0 6.5 6.5 0 0113 0z","clipRule":"evenodd"}}]})(props);
};


/***/ }),

/***/ 15787:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "w_": function() { return /* reexport */ GenIcon; }
});

// UNUSED EXPORTS: DefaultContext, IconBase, IconContext, IconsManifest

;// CONCATENATED MODULE: ./node_modules/@react-icons/all-files/lib/esm/iconsManifest.js
var IconsManifest = [
  {
    "id": "fa",
    "name": "Font Awesome",
    "projectUrl": "https://fontawesome.com/",
    "license": "CC BY 4.0 License",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
  },
  {
    "id": "io",
    "name": "Ionicons 4",
    "projectUrl": "https://ionicons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
  },
  {
    "id": "io5",
    "name": "Ionicons 5",
    "projectUrl": "https://ionicons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
  },
  {
    "id": "md",
    "name": "Material Design icons",
    "projectUrl": "http://google.github.io/material-design-icons/",
    "license": "Apache License Version 2.0",
    "licenseUrl": "https://github.com/google/material-design-icons/blob/master/LICENSE"
  },
  {
    "id": "ti",
    "name": "Typicons",
    "projectUrl": "http://s-ings.com/typicons/",
    "license": "CC BY-SA 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0/"
  },
  {
    "id": "go",
    "name": "Github Octicons icons",
    "projectUrl": "https://octicons.github.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/primer/octicons/blob/master/LICENSE"
  },
  {
    "id": "fi",
    "name": "Feather",
    "projectUrl": "https://feathericons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/feathericons/feather/blob/master/LICENSE"
  },
  {
    "id": "gi",
    "name": "Game Icons",
    "projectUrl": "https://game-icons.net/",
    "license": "CC BY 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/3.0/"
  },
  {
    "id": "wi",
    "name": "Weather Icons",
    "projectUrl": "https://erikflowers.github.io/weather-icons/",
    "license": "SIL OFL 1.1",
    "licenseUrl": "http://scripts.sil.org/OFL"
  },
  {
    "id": "di",
    "name": "Devicons",
    "projectUrl": "https://vorillaz.github.io/devicons/",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "ai",
    "name": "Ant Design Icons",
    "projectUrl": "https://github.com/ant-design/ant-design-icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "bs",
    "name": "Bootstrap Icons",
    "projectUrl": "https://github.com/twbs/icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "ri",
    "name": "Remix Icon",
    "projectUrl": "https://github.com/Remix-Design/RemixIcon",
    "license": "Apache License Version 2.0",
    "licenseUrl": "http://www.apache.org/licenses/"
  },
  {
    "id": "fc",
    "name": "Flat Color Icons",
    "projectUrl": "https://github.com/icons8/flat-color-icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "gr",
    "name": "Grommet-Icons",
    "projectUrl": "https://github.com/grommet/grommet-icons",
    "license": "Apache License Version 2.0",
    "licenseUrl": "http://www.apache.org/licenses/"
  },
  {
    "id": "hi",
    "name": "Heroicons",
    "projectUrl": "https://github.com/refactoringui/heroicons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "si",
    "name": "Simple Icons",
    "projectUrl": "https://simpleicons.org/",
    "license": "CC0 1.0 Universal",
    "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0/"
  },
  {
    "id": "im",
    "name": "IcoMoon Free",
    "projectUrl": "https://github.com/Keyamoon/IcoMoon-Free",
    "license": "CC BY 4.0 License"
  },
  {
    "id": "bi",
    "name": "BoxIcons",
    "projectUrl": "https://github.com/atisawd/boxicons",
    "license": "CC BY 4.0 License"
  },
  {
    "id": "cg",
    "name": "css.gg",
    "projectUrl": "https://github.com/astrit/css.gg",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "vsc",
    "name": "VS Code Icons",
    "projectUrl": "https://github.com/microsoft/vscode-codicons",
    "license": "CC BY 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
  }
]
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@react-icons/all-files/lib/esm/iconContext.js

var DefaultContext = {
  color: undefined,
  size: undefined,
  className: undefined,
  style: undefined,
  attr: undefined
};
var IconContext = react.createContext && react.createContext(DefaultContext);
;// CONCATENATED MODULE: ./node_modules/@react-icons/all-files/lib/esm/iconBase.js
var __assign = undefined && undefined.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};




function Tree2Element(tree) {
  return tree && tree.map(function (node, i) {
    return react.createElement(node.tag, __assign({
      key: i
    }, node.attr), Tree2Element(node.child));
  });
}

function GenIcon(data) {
  return function (props) {
    return react.createElement(IconBase, __assign({
      attr: __assign({}, data.attr)
    }, props), Tree2Element(data.child));
  };
}
function IconBase(props) {
  var elem = function (conf) {
    var attr = props.attr,
        size = props.size,
        title = props.title,
        svgProps = __rest(props, ["attr", "size", "title"]);

    var computedSize = size || conf.size || "1em";
    var className;
    if (conf.className) className = conf.className;
    if (props.className) className = (className ? className + ' ' : '') + props.className;
    return react.createElement("svg", __assign({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, conf.attr, attr, svgProps, {
      className: className,
      style: __assign(__assign({
        color: props.color || conf.color
      }, conf.style), props.style),
      height: computedSize,
      width: computedSize,
      xmlns: "http://www.w3.org/2000/svg"
    }), title && react.createElement("title", null, title), props.children);
  };

  return IconContext !== undefined ? react.createElement(IconContext.Consumer, null, function (conf) {
    return elem(conf);
  }) : elem(DefaultContext);
}
;// CONCATENATED MODULE: ./node_modules/@react-icons/all-files/lib/esm/index.js




/***/ }),

/***/ 70454:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);


var BackButton = function(param) {
    var isAppWebView = param.isAppWebView, _color = param.color, color = _color === void 0 ? "black" : _color, _top = param.top, top = _top === void 0 ? "top-4" : _top, _left = param.left, left = _left === void 0 ? "left-2" : _left;
    return null;
// const router = useRouter();
// if (!isAppWebView) {
//   return null;
// }
// return (
//   <button
//     onClick={() => router.back()}
//     className={`absolute ${top} ${left} sm:left-0 flex p-2 rounded-full backdrop-blur-sm transition-all text-brand-black group z-20`}
//   >
//     <Image
//       src={
//         color == "white"
//           ? "/icons/left-arrow-white.svg"
//           : "/icons/left-arrow.svg"
//       }
//       alt="Geri"
//       width={32}
//       height={32}
//     />
//   </button>
// );
};
/* harmony default export */ __webpack_exports__["Z"] = (BackButton);


/***/ }),

/***/ 69897:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ BlogList_Sidebar; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/bs/BsSearch.js
var BsSearch = __webpack_require__(55315);
// EXTERNAL MODULE: ./components/api.js
var api = __webpack_require__(9012);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/LoaderRemote.js
var LoaderRemote = __webpack_require__(71593);
;// CONCATENATED MODULE: ./components/BlogList/SidebarContentItem.js





var SidebarContentItem = function(param) {
    var data = param.data;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "sidebar-blog-item flex flex-row items-center justify-between py-2",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "caption flex flex-col pe-2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "mb-0 fs-7",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: data.url,
                        title: data.title,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            title: data.title,
                            className: "text-md font-medium ",
                            children: data.baslik
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "item-img shrink-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-24 h-16 rounded-lg overflow-hidden relative",
                    children: data.resim && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        objectFit: "cover",
                        objectPosition: "center",
                        src: data.resim,
                        alt: data.title,
                        loader: LoaderRemote/* default */.Z,
                        width: 96,
                        height: 64
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var BlogList_SidebarContentItem = (SidebarContentItem);

// EXTERNAL MODULE: ./context/TranslationContext.js
var TranslationContext = __webpack_require__(73040);
;// CONCATENATED MODULE: ./components/BlogList/Sidebar.js







var Sidebar = function(param) {
    var SearchOnSubmit = param.SearchOnSubmit, LastShared = param.LastShared, Popular = param.Popular;
    var ref = (0,TranslationContext/* useTranslation */.m)(), blogSidebarSearchTitle = ref.blogSidebarSearchTitle, blogSidebarSearchPlaceHolder = ref.blogSidebarSearchPlaceHolder, blogSidebarList1Title = ref.blogSidebarList1Title, blogSidebarList2Title = ref.blogSidebarList2Title;
    var ref1 = (0,react.useState)(""), searchText = ref1[0], setSearchText = ref1[1];
    var router = (0,next_router.useRouter)();
    var HandleSubmit = function(e) {
        e.preventDefault();
        SearchOnSubmit(searchText);
    // const { query } = router;
    // query.slug = [url];
    // if (searchText) {
    //   query.search = searchText;
    // } else {
    //   delete query.search;
    // }
    // router.replace(
    //   {
    //     query: query,
    //   },
    //   undefined,
    //   {
    //     scroll: true,
    //     shallow: true,
    //   }
    // );
    // SearchBlog(searchText).then((e) => {
    //   setData(e.data.result.BlogData.result);
    // });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "lg:col-span-4 col-span-12",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col mb-8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "text-xl font-semibold mb-1",
                        children: blogSidebarSearchTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                        onSubmit: HandleSubmit,
                        className: "flex",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-row justify-between pt-2 w-full",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    type: "text",
                                    value: searchText,
                                    onChange: function(e) {
                                        return setSearchText(e.target.value);
                                    },
                                    className: "border border-3 w-full py-3 rounded-l focus:outline-none text-black pl-2 font-medium",
                                    placeholder: blogSidebarSearchPlaceHolder
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "submit",
                                    className: "btn rounded-0 rounded-end flex items-center content-center bg-slate-200 px-3 rounded-r",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BsSearch/* BsSearch */.d, {})
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col mb-8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "text-xl font-semibold mb-1",
                        children: blogSidebarList1Title
                    }),
                    LastShared.map(function(e, i) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogList_SidebarContentItem, {
                            data: e
                        }, i);
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "text-xl font-semibold mb-1",
                        children: blogSidebarList2Title
                    }),
                    Popular.map(function(e, i) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogList_SidebarContentItem, {
                            data: e
                        }, i);
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var BlogList_Sidebar = (Sidebar);


/***/ }),

/***/ 3605:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _icons_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17601);
/* harmony import */ var _BackButton__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70454);





var BreadCrumb = function(param) {
    var data = param.data, isAppWebView = param.isAppWebView;
    if (data) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "bg-brand-color-primary lg:bg-brand-blue-2 w-full relative py-4 mb-6 flex items-start gap-4",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_BackButton__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                isAppWebView: isAppWebView,
                color: "white"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "container",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "pl-8 flex flex-col lg:flex-row flex-wrap items-center justify-center lg:justify-between w-full text-white",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                            className: "text-xl mm:text-2xl lg:text-4xl font-medium",
                            children: data.baslik
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                            className: "flex items-center gap-x-2 text-sm mm:text-base mt-1 lg:mt-0",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icons_icons__WEBPACK_IMPORTED_MODULE_3__/* .Icon */ .J, {
                                    name: "location",
                                    className: "hidden lg:inline-block"
                                }),
                                data.data.map(function(e, i) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        className: i > 0 ? "before:content-['/'] before:pr-2" : "",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                            href: e.url,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                title: e.title,
                                                children: e.name
                                            })
                                        })
                                    }, i);
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BreadCrumb);


/***/ }),

/***/ 71593:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ Blur; }
/* harmony export */ });
var Remote = function(param) {
    var src = param.src, width = param.width, quality = param.quality;
    if (width > 1920) width = 1920;
    return "".concat("https://cdn.balayivillasikirala.com.tr", "/uploads/").concat(width, "/").concat(src);
};
var Blur = function(src) {
    return "".concat("https://cdn.balayivillasikirala.com.tr", "/uploads/30/").concat(src);
};
/* harmony default export */ __webpack_exports__["Z"] = (Remote);


/***/ }),

/***/ 17601:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ Icon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);


var InfoIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 49562).then(__webpack_require__.bind(__webpack_require__, 49562));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(49562)
            ];
        }
    }
});
var InstagramIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 81147).then(__webpack_require__.bind(__webpack_require__, 81147));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(81147)
            ];
        }
    }
});
var LogoIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 60563).then(__webpack_require__.bind(__webpack_require__, 60563));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(60563)
            ];
        }
    }
});
var FacebookIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 55849).then(__webpack_require__.bind(__webpack_require__, 55849));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(55849)
            ];
        }
    }
});
var YoutubeIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 86759).then(__webpack_require__.bind(__webpack_require__, 86759));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(86759)
            ];
        }
    }
});
var DatepickerArrowsIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 10945).then(__webpack_require__.bind(__webpack_require__, 10945));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(10945)
            ];
        }
    }
});
var LocationIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 34364).then(__webpack_require__.bind(__webpack_require__, 34364));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(34364)
            ];
        }
    }
});
var SearchIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 39750).then(__webpack_require__.bind(__webpack_require__, 39750));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(39750)
            ];
        }
    }
});
var ArrowDownIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 5915).then(__webpack_require__.bind(__webpack_require__, 5915));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(5915)
            ];
        }
    }
});
var TimesIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 36539).then(__webpack_require__.bind(__webpack_require__, 36539));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(36539)
            ];
        }
    }
});
var PaymentOptionIcon1 = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 57905).then(__webpack_require__.bind(__webpack_require__, 57905));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(57905)
            ];
        }
    }
});
var PaymentOptionIcon2 = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 18686).then(__webpack_require__.bind(__webpack_require__, 18686));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(18686)
            ];
        }
    }
});
var HeartIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 14119).then(__webpack_require__.bind(__webpack_require__, 14119));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(14119)
            ];
        }
    }
});
var AttentionIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 55613).then(__webpack_require__.bind(__webpack_require__, 55613));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(55613)
            ];
        }
    }
});
var FaturaIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 52415).then(__webpack_require__.bind(__webpack_require__, 52415));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(52415)
            ];
        }
    }
});
var CallIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 26006).then(__webpack_require__.bind(__webpack_require__, 26006));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(26006)
            ];
        }
    }
});
var WhatsappnewIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 40305).then(__webpack_require__.bind(__webpack_require__, 40305));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(40305)
            ];
        }
    }
});
var ReverseIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 72142).then(__webpack_require__.bind(__webpack_require__, 72142));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(72142)
            ];
        }
    }
});
var MapIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 88450).then(__webpack_require__.bind(__webpack_require__, 88450));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(88450)
            ];
        }
    }
});
var Icons_new = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 793).then(__webpack_require__.bind(__webpack_require__, 793));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(793)
            ];
        }
    }
});
var Icons_new2 = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 14973).then(__webpack_require__.bind(__webpack_require__, 14973));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(14973)
            ];
        }
    }
});
var Icons_new3 = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 38796).then(__webpack_require__.bind(__webpack_require__, 38796));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(38796)
            ];
        }
    }
});
var Icons_new4 = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 68344).then(__webpack_require__.bind(__webpack_require__, 68344));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(68344)
            ];
        }
    }
});
var WorkingIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 73477).then(__webpack_require__.bind(__webpack_require__, 73477));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(73477)
            ];
        }
    }
});
var ProblemreportIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 44059).then(__webpack_require__.bind(__webpack_require__, 44059));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(44059)
            ];
        }
    }
});
var WheltimeIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 63270).then(__webpack_require__.bind(__webpack_require__, 63270));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(63270)
            ];
        }
    }
});
var GancelIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 51623).then(__webpack_require__.bind(__webpack_require__, 51623));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(51623)
            ];
        }
    }
});
var GuestconfirmationIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 21443).then(__webpack_require__.bind(__webpack_require__, 21443));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(21443)
            ];
        }
    }
});
var CloseIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 25194).then(__webpack_require__.bind(__webpack_require__, 25194));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(25194)
            ];
        }
    }
});
var VillaLocationIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 34920).then(__webpack_require__.bind(__webpack_require__, 34920));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(34920)
            ];
        }
    }
});
var PlayButtonIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 17686).then(__webpack_require__.bind(__webpack_require__, 17686));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(17686)
            ];
        }
    }
});
var DetailIncludedPriceIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 59715).then(__webpack_require__.bind(__webpack_require__, 59715));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(59715)
            ];
        }
    }
});
var BarIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 19272).then(__webpack_require__.bind(__webpack_require__, 19272));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(19272)
            ];
        }
    }
});
var CallCenterIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 18238).then(__webpack_require__.bind(__webpack_require__, 18238));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(18238)
            ];
        }
    }
});
var UserIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 78822).then(__webpack_require__.bind(__webpack_require__, 78822));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(78822)
            ];
        }
    }
});
var ClockIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 76255).then(__webpack_require__.bind(__webpack_require__, 76255));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(76255)
            ];
        }
    }
});
var PaginationPrevIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 17151).then(__webpack_require__.bind(__webpack_require__, 17151));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(17151)
            ];
        }
    }
});
var PaginationNextIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 18229).then(__webpack_require__.bind(__webpack_require__, 18229));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(18229)
            ];
        }
    }
});
var ShareIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 91788).then(__webpack_require__.bind(__webpack_require__, 91788));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(91788)
            ];
        }
    }
});
var HousekeepingIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 29097).then(__webpack_require__.bind(__webpack_require__, 29097));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(29097)
            ];
        }
    }
});
var CameraIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 22437).then(__webpack_require__.bind(__webpack_require__, 22437));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(22437)
            ];
        }
    }
});
var TeamIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 42908).then(__webpack_require__.bind(__webpack_require__, 42908));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(42908)
            ];
        }
    }
});
var CommentIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 97088).then(__webpack_require__.bind(__webpack_require__, 97088));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(97088)
            ];
        }
    }
});
var WalletIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 18688).then(__webpack_require__.bind(__webpack_require__, 18688));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(18688)
            ];
        }
    }
});
var UserodemeIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 18024).then(__webpack_require__.bind(__webpack_require__, 18024));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(18024)
            ];
        }
    }
});
var MailodemeIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 37822).then(__webpack_require__.bind(__webpack_require__, 37822));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(37822)
            ];
        }
    }
});
var PhoneodemeIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 28892).then(__webpack_require__.bind(__webpack_require__, 28892));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(28892)
            ];
        }
    }
});
var EditodemeIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 35623).then(__webpack_require__.bind(__webpack_require__, 35623));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(35623)
            ];
        }
    }
});
var LockodemeIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 9748).then(__webpack_require__.bind(__webpack_require__, 9748));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9748)
            ];
        }
    }
});
var LocationPinIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 80707).then(__webpack_require__.bind(__webpack_require__, 80707));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(80707)
            ];
        }
    }
});
var StarIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 99484).then(__webpack_require__.bind(__webpack_require__, 99484));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(99484)
            ];
        }
    }
});
var KtbIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 9842).then(__webpack_require__.bind(__webpack_require__, 9842));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9842)
            ];
        }
    }
});
var Icon = function(param) {
    var name = param.name, _size = param.size, size = _size === void 0 ? 24 : _size, className = param.className;
    var icons = {
        info: InfoIcon,
        logo: LogoIcon,
        instagram: InstagramIcon,
        facebook: FacebookIcon,
        youtube: YoutubeIcon,
        datepickerArrows: DatepickerArrowsIcon,
        location: LocationIcon,
        search: SearchIcon,
        ArrowDown: ArrowDownIcon,
        Times: TimesIcon,
        PaymentOption1: PaymentOptionIcon1,
        PaymentOption2: PaymentOptionIcon2,
        Heart: HeartIcon,
        attention: AttentionIcon,
        fatura: FaturaIcon,
        call: CallIcon,
        whatsappnew: WhatsappnewIcon,
        reverse: ReverseIcon,
        map: MapIcon,
        newIcon1: Icons_new,
        newIcon2: Icons_new2,
        newIcon3: Icons_new3,
        newIcon4: Icons_new4,
        working: WorkingIcon,
        villaLocation: VillaLocationIcon,
        PlayButton: PlayButtonIcon,
        DetailIncludedPrice: DetailIncludedPriceIcon,
        Bar: BarIcon,
        CallCenter: CallCenterIcon,
        problemreport: ProblemreportIcon,
        wheltime: WheltimeIcon,
        gancel: GancelIcon,
        guestconfirmation: GuestconfirmationIcon,
        close: CloseIcon,
        user: UserIcon,
        clock: ClockIcon,
        PaginationPrev: PaginationPrevIcon,
        PaginationNext: PaginationNextIcon,
        Share: ShareIcon,
        Wallet: WalletIcon,
        Comment: CommentIcon,
        Camera: CameraIcon,
        Housekeeping: HousekeepingIcon,
        Team: TeamIcon,
        userodeme: UserodemeIcon,
        mailodeme: MailodemeIcon,
        phoneodeme: PhoneodemeIcon,
        editodeme: EditodemeIcon,
        lockodeme: LockodemeIcon,
        LocationPin: LocationPinIcon,
        Star: StarIcon,
        ktb: KtbIcon
    };
    var Component = icons[name];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, {
        size: size,
        className: className
    });
};



/***/ })

}]);